import { Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { BooksitoutServer } from '../../../../config/BooksitoutServer'
import { useNavigate } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import LibraryMembershipAddManualTypeSearchCard from './LibraryMembershipAddManualTypeSearchCard'
import BottomCTA from '../../../../common/button/BottomCTA'
import useOwnerNamePrefill from '../useOwnerNamePrefill'

interface Props {
	onClose?: () => void
}

const LibraryMembershipAddManualContent: React.FC<Props> = ({ onClose }) => {
	const navigate = useNavigate()

	const [membershipNumber, setMembershipNumber] = useState<string>('')
	const [typeId, setTypeId] = useState<number | null>(null)
	const [password, setPassword] = useState<string>('')
	const [ownerName, setOwnerName] = useState<string>('')
	const [isOwnerNameEdited, setIsOwnerNameEdited] = useState<boolean>(false)
	const [memo, setMemo] = useState<string>('')

	const ownerNamePrefill = useOwnerNamePrefill()
	useEffect(() => {
		// Don't overwrite what the user typed while it was loading
		if (ownerNamePrefill && !isOwnerNameEdited) setOwnerName(ownerNamePrefill)
	}, [ownerNamePrefill]) // eslint-disable-line react-hooks/exhaustive-deps

	const handleSubmit = (e?) => {
		e?.preventDefault()

		if (membershipNumber === '') {
			toast.error('회원증 번호를 입력해 주세요')
			document.getElementById('membership-number-input')?.focus()
			return
		}

		toast.loading('회원증을 추가하고 있어요')
		const membership = {
			number: membershipNumber,
			typeId: typeId,
			password: password,
			ownerName: ownerName.trim(),
			memo: memo,
		}

		BooksitoutServer.post('/v1/library/membership', membership)
			.then(() => {
				toast.success('회원증을 추가했어요')
				onClose?.()
				navigate('/library/membership')
			})
			.catch(() => {
				toast.error('오류가 났어요. 잠시 후 다시 시도해 주세요')
			})
	}

	return (
		<Form onSubmit={handleSubmit}>
			<div className="d-flex align-items-center">
				<Form.Label>도서관 회원증 번호</Form.Label>
				<h6 className="ms-3 text-book">{membershipNumber.length}</h6>
			</div>
			<Form.Control id="membership-number-input" type="text" inputMode="numeric" placeholder="보통 13자리인 도서관 회원증 번호" value={membershipNumber} onChange={e => setMembershipNumber(e.target.value.replace(/\D/g, ''))} maxLength={20} autoFocus={true} autoComplete="off" />

			<div className="mt-4" />
			<Form.Label>
				종류 <span style={{ color: 'var(--sub-text-color)' }}> (예: 영등포구립도서관 등)</span>
			</Form.Label>

			<div style={{ minHeight: '200px' }}>
				<LibraryMembershipAddManualTypeSearchCard typeId={typeId} setTypeId={setTypeId} />
			</div>

			<div className="mt-4" />
			<Form.Label>회원증 비밀번호 (선택)</Form.Label>
			<Form.Control
				type="text"
				placeholder="도서관 회원증 비밀번호"
				value={password}
				onChange={e => setPassword(e.target.value)}
				autoComplete="off"
			/>

			<div className="mt-4" />
			<Form.Label>소유자 (선택)</Form.Label>
			<Form.Control
				type="text"
				placeholder="회원증 소유자 이름"
				value={ownerName}
				onChange={e => {
					setIsOwnerNameEdited(true)
					setOwnerName(e.target.value)
				}}
				maxLength={20}
				autoComplete="off"
			/>

			<div className="mt-4" />
			<Form.Label>메모</Form.Label>
			<Form.Control placeholder="회원증에 대한 메모를 남겨 보세요" onChange={e => setMemo(e.target.value)} autoComplete="off" />

			<BottomCTA message={'회원증 추가하기'} onClick={handleSubmit} />
		</Form>
	)
}

export default LibraryMembershipAddManualContent
